import { render } from "./EntitySelectorOrgaoArt.vue?vue&type=template&id=392fb08a"
import script from "./EntitySelectorOrgaoArt.vue?vue&type=script&lang=ts"
export * from "./EntitySelectorOrgaoArt.vue?vue&type=script&lang=ts"
script.render = render

export default script